package uz.ferro.erp.feature.text.ui

import emotion.react.css
import react.FC
import react.dom.html.ReactHTML.a
import react.dom.html.ReactHTML.p
import web.cssom.px
import web.window.WindowTarget

val DocLinkView: FC<DocItemProps> by lazy {
    FC { props ->
        val item = props.item
        val text = item.text ?: item.href.orEmpty()
        if (item.isNewLine == true) {
            p {
                css {
                    marginBlockStart = 0.px
                    marginBlockEnd = 0.px
                }
                a {
                    href = item.href
                    target = WindowTarget._blank
                    +text
                }
            }
        } else {
            a {
                href = item.href
                target = WindowTarget._blank
                +text
            }
        }
    }
}
